const { Star } = require("@material-ui/icons");


const dashboardNASDAQChart1 = {
  data: (canvas) => {
    let StartME=sessionStorage.getItem('StartME')
    let EndME=sessionStorage.getItem('EndME')
let Start=StartME
    let year=[]
    let data=[]

for (let i = 0; i < EndME-StartME +1; i++) {
  year.push(JSON.parse(Start) +i)
  data.push(sessionStorage.getItem(JSON.parse(Start)+i))
}
console.log(data);
    return {
      labels: year,
      datasets: [
        {
          data: data,
          fill: false,
          borderColor: "#fbc658",
          backgroundColor: "transparent",
          pointBorderColor: "#fbc658",
          pointRadius: 4,
          pointHoverRadius: 4,
          pointBorderWidth: 8,
          tension: 0.4,
        },
      
      ],
    };
  },
  options: {
    plugins: {
      legend: { display: false },
      
    },
  },
};

module.exports = {
  
  dashboardNASDAQChart1,
};
